import { Component, Inject, ViewChild, OnInit, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DialogBase, ImageType } from 't4core';
import { LocationUserInfo, TypeCategoryInfo, ObjectTypeInfo, T4Image} from 't4core';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  selector: 'EditCategoryDialog',
  templateUrl: 'EditCategoryDialog.html',
})
export class EditCategoryDialog extends DialogBase implements OnInit {
  public category: TypeCategoryInfo = new TypeCategoryInfo();
  public objectTypes: ObjectTypeInfo[] = [];
  public image: T4Image = new T4Image();

  public isReadOnly: boolean = true;

  public selectedCountryCodes: string;
  countries = [
    { name: 'Sweden', code: 'SE', selected: false },
    { name: 'Norway', code: 'NO', selected: false },
    { name: 'Denmark', code: 'DK', selected: false },
    { name: 'Germany', code: 'DE', selected: false },
    { name: 'Iceland', code: 'IS', selected: false },
    { name: 'Finland', code: 'FI', selected: false },
  ];




  @ViewChild("tblContent") private tblContent: T4DatatableWidget;
  @ViewChild("txtFile") private txtFile: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<EditCategoryDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("EditCategoryDialog");

    if (data.category) this.category = data.category;
    if (!this.category.ContextId || this.category.ContextId == this.Settings.clientSettings.ContextId) this.isReadOnly = false;

  }

  async ngOnInit() {
  this.image = await this.Api.get<T4Image>("Data/GetImage", { type: ImageType.TypeCategory, entityId: this.category.Id });
  this.objectTypes = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetTypes", { type: 0 });

    for (var i of this.objectTypes) {
      if (this.category.Content.some(x => x.Id == i.Id))
        this.tblContent.selectRow(i);
    }

    this.setInitialSelectedCountries();

  }

  public async save() {
    var token = this.beginLoad("T4.Settings.EditCategoryDialog.msgCreating", "Saving", null);

    this.category.Content = [];
    for (var i of this.tblContent.selectedRows) this.category.Content.push(i);

    await this.saveSelectedCountries();

    await this.Api.post("RentalObject/SaveCategory", this.category);
    this.endLoad(token);

    this.dialogRef.close();
  }

  public beginUpload() {
    this.txtFile.nativeElement.click();
  }

  public upload(files: FileList) {
    let me = this;
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async function () {
      console.log(reader.result);
      await me.Api.post<T4Image>("Data/SetImage", "\"" + reader.result.toString() + "\"", { type: ImageType.TypeCategory, entityId: me.category.Id });
      me.image = await me.Api.get<T4Image>("Data/GetImage", { type: ImageType.TypeCategory, entityId: me.category.Id });
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  async saveSelectedCountries() {
    this.category.Countries = this.countries
      .filter(country => country.selected)
      .map(country => country.code);
  }

  updateSelectedCountries() {
    this.selectedCountryCodes = this.countries
      .filter(country => country.selected)
      .map(country => country.code)
      .join(',');
  }

  setInitialSelectedCountries() {
    if (this.category.Countries != null) {
      this.countries.forEach(country => {
        if (this.category.Countries.includes(country.code)) {
          country.selected = true;
        }
      });
    }
  }

  public static async open(dialog: MatDialog, category: TypeCategoryInfo) {
    return await dialog.open(EditCategoryDialog, {
      minWidth: "600px",
      data: { category: category }
    }).afterClosed().toPromise();
  }
}
